/* global axios */
import ApiClient from '../ApiClient';

class CrmDashboardAPI extends ApiClient {
  constructor() {
    super('crm_dashboard', {
      saas: true,
      accountScoped: true,
    });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new CrmDashboardAPI();
